import { Link } from "react-router-dom";
import menu_data from "../../../data/home-data/MenuData";
import { useEffect, useState } from "react";

const NavMenu = () => {
   const [navClick, setNavClick] = useState<boolean>(false);

   useEffect(() => {
      window.scrollTo(0, 0);
   }, [navClick]);

   return (
 <ul className="navigation">
  {menu_data.map((menu) => {
    const hasSubMenu = !!menu.sub_menus?.length || !!menu.home_sub_menu?.length;

    return (
      <li key={menu.id} className={hasSubMenu ? "menu-item-has-children" : ""}>
        <Link onClick={() => setNavClick(!navClick)} to={menu.link}>
          {menu.title}
          {/* Optional: Show dropdown icon only if submenu exists */}
          {hasSubMenu && <span className="dropdown-icon" />}
        </Link>

        {hasSubMenu && (
          <ul className={`sub-menu ${menu.menu_class}`}>
            {menu.home_sub_menu ? (
              <>
                {menu.home_sub_menu.map((h_menu_details, i) => (
                  <li key={i}>
                    <ul className="list-wrap mega-sub-menu">
                      {h_menu_details.menu_details.map((h_menu, index) => (
                        <li key={index}>
                          <Link onClick={() => setNavClick(!navClick)} to={h_menu.link}>
                            {h_menu.title}
                            <span className={h_menu.badge_class}>{h_menu.badge}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </>
            ) : (
              menu.sub_menus?.map((sub_m, index) => (
                     <li
                        key={index}
                        className={sub_m.mega_menus ? "menu-item-has-children" : ""}
                     >
                        <Link onClick={() => setNavClick(!navClick)} to={sub_m.link}>
                           {sub_m.title}
                           {sub_m.mega_menus && <span className="dropdown-icon" />}
                        </Link>
                        {sub_m.mega_menus && (
                           <ul className="sub-menu">
                           {sub_m.mega_menus.map((mega_m, i) => (
                              <li key={i}>
                                 <Link onClick={() => setNavClick(!navClick)} to={mega_m.link}>
                                 {mega_m.title}
                                 </Link>
                              </li>
                           ))}
                           </ul>
                        )}
                     </li>
                     ))
            )}
          </ul>
        )}
      </li>
    );
  })}
</ul>

   );
};

export default NavMenu;
